import React, { useEffect, useMemo, useState } from 'react';
import { GAME_MEDALS, GAME_FOCUS, GAME_MEDAL_HISTORY } from '../data/appData';

function GameView() {
  const [historyOpen, setHistoryOpen] = useState(false);
  const historyItems = useMemo(() => [...GAME_MEDAL_HISTORY], []);

  // Level Logic (Mock)
  const currentLevel = 5;
  const levelTitle = "Atleta Espartano";
  const xpCurrent = 750;
  const xpNext = 1000;
  const xpPercent = (xpCurrent / xpNext) * 100;

  useEffect(() => {
    if (typeof document === 'undefined') return undefined;
    if (historyOpen) document.body.classList.add('modal-open');
    else document.body.classList.remove('modal-open');
    return () => document.body.classList.remove('modal-open');
  }, [historyOpen]);

  const openHistory = () => setHistoryOpen(true);
  const closeHistory = () => setHistoryOpen(false);

  // New: Level Up Alert State
  const [showLevelUp, setShowLevelUp] = useState(false);

  // Trigger Demo
  const handleLevelUpDemo = () => {
    setShowLevelUp(true);
    // Auto close after 4s (optional) or let user close
  };

  return (
    <div className="screen">

      {/* LEVEL UP MODAL */}
      {showLevelUp && (
        <div className="level-up-overlay" onClick={() => setShowLevelUp(false)}>
          <div className="level-up-card" onClick={(e) => e.stopPropagation()}>
            <div className="confetti-poppers">
              <div className="confetti"></div>
              <div className="confetti"></div>
              <div className="confetti"></div>
              <div className="confetti"></div>
              <div className="confetti"></div>
            </div>

            <span className="level-up-emoji">🏆</span>
            <h2 className="level-up-title">{levelTitle}</h2>
            <p className="level-up-sub">¡NIVEL DESBLOQUEADO!</p>

            <div className="level-up-badge">
              +500 Puntos XP
            </div>

            <div>
              <button className="pill-button pill-button-primary" onClick={() => setShowLevelUp(false)}>
                ¡A seguir entrenando!
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Hero: Level System */}
      <section className="gamification-hero">
        <span className="level-badge">NIVEL {currentLevel}</span>
        <h1 className="level-title">{levelTitle}</h1>

        <div className="xp-container">
          <div className="xp-bar">
            <div className="xp-fill" style={{ width: `${xpPercent}%` }}></div>
          </div>
          <p className="xp-text">{xpCurrent} / {xpNext} XP para subir de nivel</p>
        </div>

        {/* NEW: Demo Button */}
        <div style={{ textAlign: 'center', marginTop: '0.8rem' }}>
          <button
            className="pill-button pill-button-outline"
            style={{ fontSize: '0.75rem', padding: '0.4rem 1rem', opacity: 0.8 }}
            onClick={handleLevelUpDemo}
          >
            ✨ Demo Nivel Up
          </button>
        </div>
      </section>

      {/* Trophy Case */}
      <section className="section">
        <header className="section-header">
          <h2 className="section-title">Salón de la Fama</h2>
          <button className="link-button" onClick={openHistory}>Ver historial</button>
        </header>

        <div className="trophy-case">
          {GAME_MEDALS.map((medal) => {
            const isUnlocked = medal.status === 'Listo';
            // Map mock icons specifically for visual flair
            const icon = medal.id === 'starter' ? '🚀' : medal.id === 'streak' ? '🔥' : '🧙‍♂️';

            return (
              <div key={medal.id} className={`medal-slot ${isUnlocked ? 'unlocked' : ''}`}>
                <div className="medal-icon-3d">{icon}</div>
                <span className="medal-name">{medal.title}</span>
              </div>
            );
          })}
          {/* Add some dummy locked slots for effect */}
          <div className="medal-slot">
            <div className="medal-icon-3d">🏆</div>
            <span className="medal-name">???</span>
          </div>
          <div className="medal-slot">
            <div className="medal-icon-3d">👑</div>
            <span className="medal-name">???</span>
          </div>
          <div className="medal-slot">
            <div className="medal-icon-3d">⚔️</div>
            <span className="medal-name">???</span>
          </div>
        </div>
      </section>

      {/* Active Quests */}
      <section className="section">
        <h2 className="section-title">Misiones Activas</h2>
        <div className="quests-list">
          {GAME_FOCUS.map(quest => (
            <div key={quest.id} className="quest-item">
              <div className="quest-info">
                <h4>{quest.title}</h4>
                <p>{quest.target}</p>
              </div>
              <div className="quest-reward">
                <div className="reward-badge">+100 XP</div>
              </div>
            </div>
          ))}
          {/* Example Extra Quest */}
          <div className="quest-item">
            <div className="quest-info">
              <h4>Asistencia Perfecta</h4>
              <p>Ven 3 veces esta semana</p>
            </div>
            <div className="quest-reward">
              <div className="reward-badge">+50 XP</div>
            </div>
          </div>
        </div>
      </section>

      {/* History Modal (Kept functionality) */}
      {historyOpen && (
        <div className="medal-history-modal" role="dialog" aria-modal="true" style={{ zIndex: 2000 }}>
          <div className="medal-history-card">
            <header className="medal-history-header">
              <div>
                <p className="medal-history-eyebrow">Historial de Logros</p>
                <h2 className="medal-history-title">Tu Trayectoria</h2>
              </div>
              <button type="button" className="medal-history-close" onClick={closeHistory}>×</button>
            </header>
            <div className="medal-history-timeline">
              {historyItems.map((item) => (
                <article key={item.id} className="medal-history-item">
                  <div className="medal-history-main">
                    <h3 className="medal-history-medal">{item.medal}</h3>
                    <p className="medal-history-summary">{item.summary}</p>
                    <time className="medal-history-date">{item.achievedOn}</time>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default GameView;
